import APriceTableHeader from './index.vue';

APriceTableHeader.install = app => {
  app.component(APriceTableHeader.name, APriceTableHeader);
};

export default APriceTableHeader;
